export enum CardPaymentErrorCode {
  TechError = 'techError',
  InsufficientFunds = 'insufficientFunds',
  IncorrectCardDetails = 'incorrectCardDetails',
  IncorrectPaymentData = 'incorrectPaymentData',
}
